import { chainReducers, INITIAL_API_STATE } from 'services/api';
import {
  createAddSearchReducer,
  createDeleteSearchReducer,
  createFetchSearchReducer,
  createUpdateSearchReducer,
} from 'services/search';
import { combineReducers } from 'redux';

const fetchSearchReducer = createFetchSearchReducer('inventory');
const addSearchReducer = createAddSearchReducer('inventory');
const updateSearchReducer = createUpdateSearchReducer('inventory');
const deleteSearchReducer = createDeleteSearchReducer('inventory');

const searchChainedReducers = chainReducers(
  INITIAL_API_STATE,
  fetchSearchReducer,
  addSearchReducer,
  updateSearchReducer,
  deleteSearchReducer
);

export default combineReducers({
  searches: searchChainedReducers,
});
